<h3 mat-dialog-title i18n>Setting communication language</h3>
<p i18n>Preferred language for emails and other correspondence</p>
<mat-dialog-content>
  <form>
    <div [formGroup]="form" class="form-container">
      <mat-form-field appearance="outline">
        <mat-label i18n>Communication language</mat-label>
        <mat-select formControlName="languageCode">
          @for (option of availableLanguages; track option) {
            <mat-option [value]="option.languageCode">
              {{ option.languageName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" i18n>Discard</button>
  <button mat-flat-button color="primary" (click)="onSubmit()" i18n>Save</button>
</mat-dialog-actions>
